import { render, staticRenderFns } from "./SessionTable.vue?vue&type=template&id=bdaeb432&"
import script from "./SessionTable.vue?vue&type=script&lang=js&"
export * from "./SessionTable.vue?vue&type=script&lang=js&"
import style0 from "./SessionTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VDataTable,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/Users/musili/musilidev/webroot/work-bmm/01_DEX/dex/front-end/web-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdaeb432')) {
      api.createRecord('bdaeb432', component.options)
    } else {
      api.reload('bdaeb432', component.options)
    }
    module.hot.accept("./SessionTable.vue?vue&type=template&id=bdaeb432&", function () {
      api.rerender('bdaeb432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenant/views/SubscriptionSubmissions/Components/SessionTable.vue"
export default component.exports